import { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import lodash from 'lodash';

import { PageTitleWrapper } from '../../../components/PageTitleWrapper';
import { OrganisationFilter } from '../../../components/OrganisationFilter';
import { PageTitle } from '../../../components/PageTitle';
import { CategoryStats } from '../components/CategoryStats';

import { useOrganisation } from '../../../hooks/organisations';
import { useQuestions } from '../../../hooks/questions';

import { Container } from '../styles';

export const Life: React.FC = () => {
  const { currentOrganisation, chosenDivisionId } = useOrganisation();
  const { lifeQuestionnaires } = useQuestions();

  const { life } = useMemo(() => {
    const orgAverageScore = lodash.get(
      currentOrganisation,
      `scores.${chosenDivisionId}`
    );

    if (orgAverageScore) {
      return orgAverageScore;
    }

    return {
      life: {}
    };
  }, [currentOrganisation, chosenDivisionId]);

  return (
    <Container>
      <OrganisationFilter hideUserSearch />

      <Helmet>
        <title>Life summary</title>
      </Helmet>

      <PageTitleWrapper>
        <PageTitle heading="Life summary" />
      </PageTitleWrapper>

      <CategoryStats
        categoryData={life}
        categoryQuestionnaires={lifeQuestionnaires}
        isLife
      />
    </Container>
  );
};
